module.exports = __webpack_public_path__ + "static/media/loanEligible.892ace31.svg";